import { showSuccess, showError } from '../../index.js'

export default {
  namespaced: true,
  state () {
    return {
      subscriptions: []
    }
  },
  getters: {
    backendSubscriptions (state) {
      return state.subscriptions
    }
    // getHorizontalData (state) {
    //   return state.subscriptions.filter(item => item.direction === 'horizontal').map(item => item.numOrder)
    // },
    // getVerticalData (state) {
    //   return state.subscriptions.filter(item => item.direction === 'vertical').map(item => item.numOrder)
    // }
  },
  mutations: {
    setSubscriptions (state, payload) {
      state.subscriptions = payload
    }
  },
  actions: {
    async getSubscriptionByPageWithFilter (context, { filteredTerm, pageNumber = 1 }) {
      /* eslint-disable */
      let totalForPage = 1

      await context.rootState.authAxios.get('/SubscriptionDetails/GetSubDetailByPageWithFilter', {
        params: {
          filteredTerm: filteredTerm,
          pageNumber: pageNumber
        }
      }).then((response) => {
        const responseData = response.data.paginatedData
        totalForPage = Math.ceil(response.data.totalRecords / 10)
        context.commit('setSubscriptions', responseData)
      }).catch((error) => {
        showError('Đã xảy ra lỗi không mong muốn')
      })

      return totalForPage
    },
    async updateSubscription (context, payload) {
      await context.rootState.authAxios.put(`/SubscriptionDetails/${payload.id}`, payload
      ).then(() => {
        showSuccess('Cập nhật thành công')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    },
    async deleteSubscription (context, payload) {
      await context.rootState.authAxios.delete(`SubscriptionDetails/${payload}`
      ).then(() => {
        showSuccess('Xóa thành công')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    },
    async exportExcel (context, { filteredTerm }) {
      await context.rootState.authAxios.get('/SubscriptionDetails/SubscribeReport', 
        { responseType: 'blob',
          params: {
            filteredTerm: filteredTerm
          }
         })
        .then((res) => {
          const filename = res.headers['content-disposition']
            .split(';')
            // eslint-disable-next-line
            .find(function (el) {
              if (el.includes('filename=')) return el
            })
            .replace('filename=', '')
            .trim()
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: 'application/vnd.ms-excel;charset=utf-8'
            })
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename) // or any other extension
          document.body.appendChild(link)
          link.click()

          // Cleanup
          link.remove()
          window.URL.revokeObjectURL(url)
        }).catch((error) => {
          if (error.response.data.error_message) {
            showError(error.response.data.error_message)
          } else {
            showError('Đã xảy ra lỗi không mong muốn')
          }
        })
    }
  }
}
